import { render, staticRenderFns } from "./ReferralForm.vue?vue&type=template&id=06ab0e6c&scoped=true&"
import script from "./ReferralForm.vue?vue&type=script&lang=js&"
export * from "./ReferralForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferralForm.vue?vue&type=style&index=0&id=06ab0e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ab0e6c",
  null
  
)

export default component.exports